// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class OrganizationalUnitGroup extends TrackingModel {
	public OrganizationalUnitGroupId: number = 0;
	public OrganizationalUnitId: number = 0;
	public GroupId: number = 0;
}